import React, { useEffect, useState, useContext } from "react";
import "../css/Dashboard.css";
import { AuthContext } from "../context/AuthContext";

const Dashboard = () => {
  const { authFetch } = useContext(AuthContext);

  const [income, setIncome] = useState({
    daily: 0,
    weekly: 0,
    monthly: 0,
    yearly: 0,
  });

  const [loading, setLoading] = useState(true);

  // Fetch income data from API
  useEffect(() => {
    const fetchIncomeData = async () => {
      try {
        const data = await authFetch("https://printmycake.com/cms/api/income.php");
        setIncome({
          daily: data.daily || 0,
          weekly: data.weekly || 0,
          monthly: data.monthly || 0,
          yearly: data.yearly || 0,
        });
      } catch (error) {
        console.error("Error fetching income data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchIncomeData();
  }, [authFetch]);

  if (loading) {
    return (
      <div className="dashboard-container">
        <h2>Loading dashboard...</h2>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Dashboard</h1>

      {/* Income Summary */}
      <div className="income-grid">
        <div className="income-card daily">
          <h2>Daily Income</h2>
          <p>${income.daily.toFixed(2)}</p>
        </div>
        <div className="income-card weekly">
          <h2>Weekly Income</h2>
          <p>${income.weekly.toFixed(2)}</p>
        </div>
        <div className="income-card monthly">
          <h2>Monthly Income</h2>
          <p>${income.monthly.toFixed(2)}</p>
        </div>
        <div className="income-card yearly">
          <h2>Yearly Income</h2>
          <p>${income.yearly.toFixed(2)}</p>
        </div>
      </div>

      {/* Bar Chart */}
      <div className="chart-section">
        <h2>Income Overview</h2>
        <div className="chart">
          <div
            className="chart-bar daily-bar"
            style={{ height: `${income.daily / income.yearly * 100 || 5}%` }}
          >
            <span>${income.daily.toFixed(0)}</span>
          </div>
          <div
            className="chart-bar weekly-bar"
            style={{ height: `${income.weekly / income.yearly * 100 || 5}%` }}
          >
            <span>${income.weekly.toFixed(0)}</span>
          </div>
          <div
            className="chart-bar monthly-bar"
            style={{ height: `${income.monthly / income.yearly * 100 || 5}%` }}
          >
            <span>${income.monthly.toFixed(0)}</span>
          </div>
          <div
            className="chart-bar yearly-bar"
            style={{ height: `${income.yearly / income.yearly * 100 || 5}%` }}
          >
            <span>${income.yearly.toFixed(0)}</span>
          </div>
        </div>
        <div className="chart-labels">
          <span>Daily</span>
          <span>Weekly</span>
          <span>Monthly</span>
          <span>Yearly</span>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
